import { useState } from 'react';

const ValidationSchemaOptions = {
  abortEarly: false,
  stripUnknown: true,
};
const validate = (row, schema, setIsValid, setErrors) => async () => {
  const isValid = true;
  let errorMessages = {};
  setIsValid(true);
  setErrors(errorMessages);
  try {
    await schema.validate(row, ValidationSchemaOptions);
    return { isValid, errorMessages };
  } catch (e) {
    errorMessages = e.inner.reduce((acum, cur) => {
      acum[cur.path] = cur.errors.join(', ');
      return acum;
    }, {});

    setIsValid(false);
    setErrors(errorMessages);
    return { isValid: false, errorMessages };
  }
};

const useValidation = (creatingData, schema) => {
  const [isValid, setIsValid] = useState(true);
  const [errors, setErrors] = useState(null);

  const [row, setRow] = useState(creatingData);
  const validateRow = validate(row, schema, setIsValid, setErrors);
  return {
    row,
    setRow: async (data) => {
      setRow(data);
    },
    isValid,
    messageErrors: errors || {},
    validate: validateRow,
  };
};

export default useValidation;
